import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center px-6" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="w-full max-w-md bg-surface border border-white/[0.08] p-10">
        <Link to="/" data-testid="login-back-home" className="font-serif text-3xl text-cream">
          LW<span className="text-bronze">&amp;</span>CO
        </Link>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone-500 mt-3 mb-10">Admin workspace</p>
        <form onSubmit={submit} className="space-y-6" data-testid="admin-login-form">
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 mb-2" htmlFor="admin-email">Email</label>
            <input id="admin-email" data-testid="admin-email-input" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="admin@lwandco.co.nz"
              className="w-full bg-charcoal border border-white/10 px-4 py-3.5 text-sm text-cream placeholder:text-stone-600 focus:outline-none focus:border-bronze transition-colors" />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-[0.2em] text-stone-500 mb-2" htmlFor="admin-password">Password</label>
            <input id="admin-password" data-testid="admin-password-input" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="w-full bg-charcoal border border-white/10 px-4 py-3.5 text-sm text-cream placeholder:text-stone-600 focus:outline-none focus:border-bronze transition-colors" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="w-full py-4 bg-bronze text-obsidian font-semibold text-sm tracking-wide hover:bg-cedar disabled:opacity-50 transition-colors">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
